import { UserHttpService } from 'core/services/user';
import { useState, useEffect } from 'react';

export const useEducationForm = (id) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        if (id) {
            loadEducation();
        }
    }, [id]);

    const loadEducation = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await UserHttpService.getEducation(id);
            setData(response);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const saveEducation = async (formData) => {
        setIsLoading(true);
        setError(null);
        try {
            let response;
            if (id) {
                response = await UserHttpService.updateEducation({ ...formData, id });
            } else {
                response = await UserHttpService.createEducation(formData);
            }
            return response;
        } catch (err) {
            setError(err.message);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        error,
        data,
        saveEducation
    };
};

export default useEducationForm; 